import { render, staticRenderFns } from "./mainLoginPage.vue?vue&type=template&id=7bb17098&scoped=true&"
import script from "./mainLoginPage.vue?vue&type=script&lang=js&"
export * from "./mainLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./mainLoginPage.vue?vue&type=style&index=0&id=7bb17098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb17098",
  null
  
)

export default component.exports